import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consolidated-report',
  templateUrl: './consolidated-report.component.html',
  styleUrls: ['./consolidated-report.component.scss']
})
export class ConsolidatedReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
